module.exports = __webpack_public_path__ + "img/logo.90ecccc9.png";